import { ActionFunction, redirect } from 'react-router-dom';

// Sentry
import * as Sentry from '@sentry/react';

// GQL
import { formOrderNaming } from '../../../../../components/forms/NewWorkOrderForm/constants';

// Actions
import { passData } from './ActionUtils/passData';
import { saveData } from './ActionUtils/saveData';
import { showSuccessToast } from '../../../../../utils/toasts';
import i18n from '../../../../../i18n';

function isOfflineQueuedError(err: unknown): boolean {
  const e = err as {
    offlineQueued?: boolean;
    message?: string;
    networkError?: { offlineQueued?: boolean };
  };
  return (
    e?.offlineQueued === true ||
    e?.networkError?.offlineQueued === true ||
    (e?.message ?? '').includes('Mutation queued for offline sync')
  );
}

export const ActionCampaignSummary: ActionFunction = async ({ request }) => {
  const formData = await request.formData();
  const intent = formData.get('intent');
  if (intent === 'pass-data') {
    try {
      return passData(formData);
    } catch (err) {
      Sentry.captureException(err);
      console.log('Error:', err);
    }
  }
  if (intent === 'save-data') {
    try {
      const dataFormRaw = sessionStorage.getItem(
        formOrderNaming.NEW_CAMPAIGN_FORM
      );
      return await saveData(dataFormRaw);
    } catch (err) {
      // Bloque C-7.5: si la mutation se encoló offline, redirigimos a la lista
      // sin propagar a ErrorPage. Al reconectar, syncOfflineQueue replay-ea
      // SaveCampaign (o SaveGenericOrder en la rama Generic).
      if (isOfflineQueuedError(err)) {
        showSuccessToast(i18n.t('modals:changeState.queuedOffline'));
        sessionStorage.removeItem(formOrderNaming.NEW_CAMPAIGN_FORM);
        window.dispatchEvent(new CustomEvent('offline-campaign-queued'));
        return redirect('/work-orders/campaign');
      }
      Sentry.captureException(err);
      console.log('> NewCampaignSummary - error creating:', err);
    }
  }
  return null;
};
